import _Blog from './Blog'

export const Blog = _Blog

export default _Blog
